import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const Signup = function () {
  const { user } = useContext(AuthContext);
  const URL_SIGNUP = process.env.REACT_APP_URL_USERS;
  const URL_BROKERS = process.env.REACT_APP_URL_BROKERS;
  const URL_FORWARDERS = process.env.REACT_APP_URL_FORWARDERS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [text, setText] = useState(false);
  const [tipo, setTipo] = useState("");
  const [telefono, setTelefono] = useState();
  const [idioma, setIdioma] = useState();
  const [brokers, setBrokers] = useState([]);
  const [forwarders, setForwarders] = useState([]);
  const [selectedBroker, setSelectedBroker] = useState("");
  const [selectedForwarder, setSelectedForwarder] = useState("");
  const [selectedCliente, setSelectedCliente] = useState("");
  const [clientes, setClientes] = useState([]);
  const [t, i18n] = useTranslation("global");

  useEffect(() => {
    axios
    .get(`${URL_BROKERS}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allBrokers = res.data;
        setBrokers(allBrokers);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
    .get(`${URL_FORWARDERS}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allForwarders = res.data;
        setForwarders(allForwarders);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
    .get(`${URL_CLIENTES}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [])

  const handleForm = (event) => {
    event.preventDefault();
    if(tipo == "Admin"){
      axios
      .post(
       URL_SIGNUP,
        {
          nombre: firstName,
          apellido: lastName,
          email,
          password,
          tipo,
          telefono,
          idioma
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
    }else if(tipo == "Broker"){
      axios
      .post(
       URL_SIGNUP,
        {
          nombre: firstName,
          apellido: lastName,
          brokers: selectedBroker,
          email,
          password,
          tipo,
          telefono, 
          idioma
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
    }else if(tipo == "Forwarder"){
      axios
      .post(
       URL_SIGNUP,
        {
          nombre: firstName,
          apellido: lastName,
          forwarders: selectedForwarder,
          email,
          password,
          tipo,
          telefono,
          idioma
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
    }else if(tipo == "Cliente"){
      axios
      .post(
       URL_SIGNUP,
        {
          nombre: firstName,
          apellido: lastName,
          clientes: selectedCliente,
          email,
          password,
          tipo,
          telefono,
          idioma
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
    }
    
  };



  return (
    <>
        <div>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <span className="page-title-icon"><i className="fas fa-user-plus" /></span>
                {t("Nuevo")} {t("Usuario")}
              </h3>
              <p className="page-subtitle">{t("Alta de acceso al sistema")}</p>
            </div>
          </div>
          <Form onSubmit={handleForm}>
          <div className="form-section">
            <div className="form-section-header"><i className="fas fa-id-badge" /><h4 className="form-section-title">{t("Tipo de usuario")}</h4></div>
            <div className="form-section-body">
          <Label>Tipo</Label>
              <Input
                value={tipo}
                onChange={(e) => setTipo(e.target.value)}
                type="select"
                
              >
                <option value="">{("Selecciona")}</option>
                <option value="Admin">Admin</option>
                <option value="Broker">Broker</option>
                <option value="Forwarder">Forwarder</option>
                <option value="Cliente">Cliente</option>
                </Input>

                {tipo == "Broker" ? (
                    <>
                    <Label>Broker</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedBroker}
                      required
                      onChange={(e) => {
                        setSelectedBroker(e.target.value);
                      }}
                    >
                      <option value="0">{t("Selecciona")}</option>
                      {brokers
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                            return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                    </>
                ): undefined}


                  {tipo == "Forwarder" ? (
                    <>
                    <Label>Forwarder</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedForwarder}
                      required
                      onChange={(e) => {
                        setSelectedForwarder(e.target.value);
                      }}
                    >
                      <option value="0">{t("Selecciona")}</option>
                      {forwarders
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                            return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                    </>
                ): undefined}


{tipo == "Cliente" ? (
                    <>
                    <Label>Cliente</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedCliente}
                      required
                      onChange={(e) => {
                        setSelectedCliente(e.target.value);
                      }}
                    >
                      <option value="0">{t("Selecciona")}</option>
                      {clientes
                        .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                        .map((a) => {
                            return <option value={a._id}>{a.nombre_comercial}</option>;
                        })}
                    </Input>
                    </>
                ): undefined}
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header"><i className="fas fa-info-circle" /><h4 className="form-section-title">{t("Datos generales")}</h4></div>
            <div className="form-section-body">
              <Label>Nombre</Label>
              <Input
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                type="text"
                
              />
              <Label>Apellido</Label>
              <Input
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                type="text"
                name="lastName"
                placeholder="Apellido"
              />
              <Label>Email</Label>
              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                name="email"
                placeholder="Email"
              />
              <Label>Telefono</Label>
              <Input
                value={telefono}
                onChange={(e) => setTelefono(e.target.value)}
                type="number"
                id="firstName"
                
              />

          <Label className="mr-sm-2">{t("Idioma")}</Label>
          <Input
            className="col-sm-12"
            type="select"
            value={idioma}
            required
            onChange={(e) => {
              setIdioma(e.target.value);
            }}
          >
            <option value="">Selecciona</option>;
            <option value="es">Español</option>;
            <option value="en">English</option>;
          </Input>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header"><i className="fas fa-lock" /><h4 className="form-section-title">{t("Acceso")}</h4></div>
            <div className="form-section-body">
              <Label>Contraseña</Label>
              <Input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                name="password"
                placeholder="Contraseña"
              />
            </div>
          </div>
          <div className="submit-bar">
            {user.menu_usuarios?(
            <Button type="submit" color="success">
            <i className="fas fa-save" /> Dar de Alta
          </Button>
          ): (
            <Button type="submit" color="success" disabled>
            <i className="fas fa-save" /> Dar de Alta
          </Button>
          ) }
          </div>

          </Form>
      </div>
    </>
  );
};

export default Signup;
